'use strict';

import { Entity } from '../Entity';

export enum UserCalendarProviderType {
  GMAIL = 'Gmail',
  OUTLOOK = 'Outlook/iCal',
}

export class UserCalendarProvider extends Entity {
  protected calendarProviderId;
  protected calendarProvider;
  protected iframe;

  constructor() {
    super();
  }

  public hydrate(data: any) {
    this.calendarProviderId = data.calendarProviderId;
    this.calendarProvider = data.calendarProvider;
    this.iframe = data.iframe;
  }

  public getCalendarProviderId() {
    return this.calendarProviderId;
  }

  public getCalendarProvider() {
    return this.calendarProvider;
  }

  public getIframe() {
    return this.iframe;
  }
}
